import PIEText from '@src/shared/components/PIEText';
import React, { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { globalStyles } from 'snacks-design-system';
interface componentProps {
  to: any;
  children: ReactNode;
  className: string;
  activeClassName: string;
  isActive?: any;
  external?: boolean;
}

const { xdsColorContentSubdued } = globalStyles;
const DesktopHeaderTextNavLink = ({
  to,
  children,
  className,
  activeClassName,
  isActive,
  external,
}: componentProps) => {
  return (
    <NavLink
      to={!external ? to : false}
      className={className}
      activeClassName={activeClassName}
      isActive={isActive}
      onClick={() => {
        if (external) {
          window.location = to;
        }
      }}
    >
      <PIEText
        size="var(--xds-font-size-16)"
        fontWeight="var(--xds-font-weight-bold)"
        color={xdsColorContentSubdued}
        text={children}
      />
    </NavLink>
  );
};
export default DesktopHeaderTextNavLink;
